import gsap from 'gsap'
import { RefObject, useLayoutEffect } from 'react'

const getModalDialog = () => document.querySelector<HTMLElement>('#modal [data-element="modal-dialog"]')

const useKeyboardDialogOffset = (visible: boolean, keyboardRef: RefObject<HTMLElement | null>) => {
  useLayoutEffect(() => {
    const modalDialog = getModalDialog()

    if (!visible || !modalDialog || !keyboardRef.current) {
      return
    }

    const keyboardHeight = keyboardRef.current.getBoundingClientRect().height
    gsap.to(modalDialog, { y: -keyboardHeight / 2, duration: 0.18, ease: 'power2.out' })

    return () => {
      const dialog = getModalDialog()
      if (dialog) {
        gsap.to(dialog, { y: 0, duration: 0.18, ease: 'power2.out' })
      }
    }
  }, [keyboardRef, visible])
}

export default useKeyboardDialogOffset
